import type { IEnergyPassportDetails, IEnergyPassportProduct } from "@/entities/energy-passport/types.ts"
import type { IEnergyPassportDetailsEditableField } from "@/features/energy-passport/ui/detail-tables/model/store.ts"
import type { IEnergyPassportDetailsCell } from "@/features/energy-passport/ui/detail-tables/model/types.ts"
import { energyPassportProductColumns } from "@/features/energy-passport/ui/main-table/components/energy-passport-product-row.tsx"
import type { IEnergyPassportProductEditableField } from "@/features/energy-passport/ui/main-table/model/store.ts"

export function calculateEnergyTotals(products: IEnergyPassportProduct[]): Record<IEnergyPassportProductEditableField, number | string> {
  return energyPassportProductColumns.reduce(
    (totals, column) => {
      if (column.inputType === "string") {
        totals[column.field] = "-"
      } else {
        totals[column.field] = products.reduce((acc, product) => {
          const value = product[column.field]
          // Old version
          // if (column.field === "active_energy" || column.field === "reactive_energy") {
          //   return acc + (typeof value === "number" ? value : Number.parseInt(value || "0")) * product.count
          // }
          return acc + (typeof value === "number" ? value : Number.parseInt(value || "0")) || 0
        }, 0)
      }
      return totals
    },
    {} as Record<IEnergyPassportProductEditableField, number | string>
  )
}

export function calcEnergyPassportDetailsQuartersTotals(
  cells: IEnergyPassportDetailsCell[],
  products: IEnergyPassportDetails[]
): Record<IEnergyPassportDetailsEditableField, number> {
  return cells.reduce(
    (totals, field) => {
      if (typeof field === "string") {
        totals[field] = products.reduce((acc, product) => {
          const value = product[field]
          if (field === "declared_consumption") {
            return acc + (product.sub_consumption + calcAllDetailsNeed(product))
          }
          if (field === "total_consumption") {
            return acc + calcAllDetailsNeed(product)
          }
          return acc + (typeof value === "number" ? value : Number.parseInt(value || "0")) || 0
        }, 0)
      }
      return totals
    },
    {} as Record<IEnergyPassportDetailsEditableField, number>
  )
}

export function calcAllDetailsNeed(quarter: IEnergyPassportDetails) {
  return quarter.technical_needs + quarter.own_needs + quarter.residential_needs + quarter.production_needs
}
